import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { dashboardService } from '../../services/dashboardService';

interface Props { year?: string; month?: string }
export const ResumoCards: React.FC<Props> = ({ year, month }) => {
  const { user, isGrupo, isEmpresa } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      if (!user) return;
      setLoading(true);
      try {
        const params: any = {};
        if (year) params.year = Number(year);
        if (month) params.month = Number(month);
        
        let res;
        if (isGrupo && user.grupoId) {
          res = await dashboardService.grupoOverview(user.grupoId, params);
        } else if (isEmpresa && user.empresaId) {
          res = await dashboardService.empresaOverview(user.empresaId, params);
        } else {
          throw new Error('Usuário não tem empresa ou grupo associado');
        }
        
        // the endpoint may return { data: {...} } or the object directly
        const payload = res?.data ?? res;
        setData(payload);
      } catch (err) {
        console.error('Erro ao carregar dashboard resumo:', err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    if (user && (isEmpresa || isGrupo)) load();
  }, [user, isGrupo, isEmpresa, month, year]);

  const fmt = (v: any) => {
    if (v === undefined || v === null) return '—';
    if (typeof v === 'number') return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return String(v);
  };
  const periodLabel = () => {
    if (!year && !month) return 'Período: Todos';
    if (year && month) return `Período: ${month}/${year}`;
    if (year) return `Período: ${year}`;
    return `Período: ${month}`;
  };

  return (
    <div>
      <div className="text-xs text-gray-600 mb-2">{periodLabel()}</div>
  <div className="grid grid-cols-2 gap-2 mt-2">
      <div className="p-3 rounded shadow" style={{ backgroundColor: '#FEF3E2', color: '#8B6914' }}>
        <h3 className="text-xs font-semibold">Total de Clientes</h3>
        <p className="text-lg font-bold">{loading ? 'Carregando...' : data?.totalClientes ?? '—'}</p>
      </div>
      <div className="p-3 rounded shadow" style={{ backgroundColor: '#E8F8F4', color: '#146B54' }}>
        <h3 className="text-xs font-semibold">Total de Documentos</h3>
        <p className="text-lg font-bold">{loading ? 'Carregando...' : data?.totalDocumentos ?? '—'}</p>
      </div>

      <div className="p-3 rounded shadow" style={{ backgroundColor: '#F0EDFF', color: '#4A3B7A' }}>
        <h3 className="text-xs font-semibold">Prêmios Totais Emitidos</h3>
        <p className="text-lg font-bold">{loading ? 'Carregando...' : fmt(data?.premiosTotais)}</p>
      </div>

      <div className="p-3 rounded shadow" style={{ backgroundColor: '#FDE8ED', color: '#8B3A4D' }}>
        <h3 className="text-xs font-semibold">Comissões Totais</h3>
        <p className="text-lg font-bold">{loading ? 'Carregando...' : fmt(data?.comissoesTotais)}</p>
      </div>
      </div>
    </div>
  );
};

export default ResumoCards;